import * as React from 'react';

const SvgUpload = (props) => (
  <svg
    width={26}
    height={26}
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.76953 6.53845L13.0003 3.30768M13.0003 3.30768L16.2311 6.53845M13.0003 3.30768L13.0003 16.2308"
      stroke="white"
      strokeWidth={2.15385}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.15426 9.76921V9.76921C5.4778 9.76921 3.3081 11.9389 3.30811 14.6154L3.30811 16.9487C3.30811 20.1208 5.8796 22.6923 9.0517 22.6923L16.9491 22.6923C20.1212 22.6923 22.6927 20.1208 22.6927 16.9487L22.6927 14.6154C22.6927 11.9389 20.523 9.76921 17.8466 9.76921V9.76921"
      stroke="white"
      strokeWidth={2.15385}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SvgUpload;
